import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export function useSuperAdmin() {
  const { user, loading: authLoading } = useAuth();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      setIsSuperAdmin(false);
      setIsLoading(false);
      return;
    }

    async function check() {
      const { data, error } = await supabase
        .from("profiles")
        .select("is_super_admin")
        .eq("user_id", user!.id)
        .maybeSingle();

      if (error || !data) {
        setIsSuperAdmin(false);
      } else {
        setIsSuperAdmin((data as any).is_super_admin === true);
      }
      setIsLoading(false);
    }

    check();
  }, [user, authLoading]);

  return { isSuperAdmin, isLoading };
}
